module.exports = __webpack_public_path__ + "static/media/ic_rec.3a5f5568.svg";